export default "__VITE_ASSET__DtRKug$v__"